<template>
    
        <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>
    
    <h3 style="text-align: left;">Informacion General</h3>
    <div class="col-md-12 row">
        <div class="col-md-5">
            <label for="">Razón social como aparece en la constacia fiscal</label>
            <input class="form-control" type="text" v-model="razon_social"/>
        </div>
        
        <div class="col-md-2">
            <label for="">Telefono</label>
            <input class="form-control" type="text" v-model="telefono"/>
        </div>
        <div class="col-md-3">
            <label for="">Email</label>
            <input class="form-control" type="text" v-model="email"/>
        </div>
        <div class="col-md-2">
            <label for="">RFC</label>
            <input class="form-control" type="text" v-model="rfc"/>
        </div>
    </div>
    <div class="col-md-12 row">
        <div class="col-md-5">
            <label for="">Nombre comercial</label>
            <input class="form-control" type="text" v-model="constancia_fiscal"/>
        </div>
        <div class="col-md-2">
            <label for="">Tipo</label>
            <select name="" id="" v-model="regimen_fiscal" class="form-control">
                <option value="Conexion">Conexion</option>
                <option value="Interconexion">Interconexion</option>

            </select>
            
        </div>
        <div class="col-md-4">
            <label for="">Tipo conflicto Interes</label>
            <select name="" id="" v-model="forma_de_pago" class="form-control">
                <option value="Ningún Riesgo o bajo Riesgo">Ningún Riesgo o bajo Riesgo</option>
                <option value="Riesgo mediano">Riesgo mediano</option>
                <option value="Riesgo Alto">Riesgo Alto</option>
                <option value="Riesgo Máximo">Riesgo Máximo</option>

            </select>
            
        </div>

    </div>
    <!--<div class="col-md-12 row">
        <div class="col-md-5">
            <label for="">Uso de CFDI</label>
            <input class="form-control" type="text" v-model="cfdi"/>
        </div>
        <div class="col-md-2">
            <label for="">Forma de pago</label>
            <input class="form-control" type="text" v-model="forma_de_pago"/>
        </div>
        <div class="col-md-3">
            <label for="">Método de pago</label>
            <input class="form-control" type="text" v-model="metodo_de_pago"/>
        </div>
        <div class="col-md-2">
            <label for="">Regimen Fiscal</label>
            <input class="form-control" type="text" v-model="regimen_fiscal">
        </div>
    </div>
    <div class="col-md-12 row">
        <div class="col-md-5">
            <label for="">C.P de Domicilio Fiscal</label>
            <input class="form-control" type="text" v-model="cp_domicilio_fiscal"/>
        </div>
        <div class="col-md-4">
            <label for="">Constancia Fiscal</label>
            <input type="file" @change="onFileChangeArchivo($event, 'pdfFile1')" accept="application/pdf" class="form-control"/>
        </div> 
        <div v-if="constancia_fiscal"  class="col-md-3"><br>
            <iframe  :src=" constancia_fiscal" width="300" height="150" ></iframe>
        </div>
        
    </div>
    <div class="col-md-12 row">
       
        <div v-if="constancia_fiscal" class="col-md-12" style="text-align: right;">
            <button type="button" class="btn btn-outline-warning" @click="downloadPDF(constancia_fiscal)"><i class="mdi mdi-arrow-down-bold-box" aria-hidden="true"></i>Descargar</button> &nbsp;
            <button type="button" class="btn btn-outline-danger" @click="eliminar_RFC()"> <i class="mdi mdi-delete-forever" aria-hidden="true"></i>  Eliminar</button>

        </div>
    </div>-->
    <hr>
    <h3 style="text-align: left;">Domicilio</h3>
    <div class="col-md-12 row">
        <div class="col-md-5">
            <label for="">Calle</label>
            <input class="form-control" type="text" v-model="calle"/>
        </div>
        <div class="col-md-2">
            <label for="">Numero exterior</label>
            <input class="form-control" type="text" v-model="numero_exterior"/>
        </div>
        <div class="col-md-3">
            <label for="">Numero interior</label>
            <input class="form-control" type="text" v-model="numero_interior"/>
        </div>
        <div class="col-md-2">
            <label for="">Colonia</label>
            <input class="form-control" type="text" v-model="colonia"/>
        </div>
    </div>

    <div class="col-md-12 row">
        <div class="col-md-5">
            <label for="">Codigo postal</label>
            <input class="form-control" type="text" v-model="codigo_postal"/>
        </div>
        <div class="col-md-2">
            <label for="">Municipio</label>
            <input class="form-control" type="text" v-model="municipio"/>
        </div>
        <div class="col-md-3">
            <label for="">Estado</label>
            <input class="form-control" type="text" v-model="estado">
        </div>
        
    </div>
    <hr>
    <!--<div class="col-md-12">
        <h3>Documentos</h3>
        <div class="col-md-5">
            <label for="">Documento de RFC * Opcional</label>
            <input type="file" @change="onFileChangeArchivo($event, 'pdfFile2')" accept="application/pdf" class="form-control"/>
            <br>
            
        
        </div>
        <div v-if="url_rfc"  class="col-md-5">
            <iframe  :src=" url_rfc" width="300" height="150" ></iframe>
        </div>
        <div v-if="url_rfc" class="col-md-5">
            <button type="button" class="btn btn-outline-warning" @click="downloadPDF(url_rfc)"><i class="mdi mdi-arrow-down-bold-box" aria-hidden="true"></i>Descargar</button> &nbsp;
            <button type="button" class="btn btn-outline-danger" @click="eliminar_RFC()"> <i class="mdi mdi-delete-forever" aria-hidden="true"></i>  Eliminar</button>

        </div>
        
    </div><br> -->
    <div class="col-md-12 row">
        <h3 style="text-align: left;">TIPO DE TECNOLOGIA (SFV SISTEMA FOTOVOLTAICO, EÓLICO, HIDRÁULICO, CICLO COMBINADO, VAPOR, TÉRMICO, ETC.)</h3>
        <div class="col-md-12">
            <label for="">Tecnologia</label>
            <input class="form-control" type="text" v-model="tecnologia"/>
        </div>
       
       
    </div>
    <div class="py-3 col-md-12 row">
       
       
        <div class="col-md-5">
            <label for="">Oficio de CFE / CENACE - opcional Tamaño máximo 5 MB</label>
            
            <input type="file" @change="onFileChangeArchivo($event, 'pdfFile3')" accept="application/pdf" class="form-control"/>

        </div>
    </div><br> 
    <div v-if="url_cfe "  class="col-md-5">
        <iframe  :src=" url_cfe" width="300" height="150" ></iframe>
    </div> 
    <div v-if="url_cfe " class="col-md-5">
        <button type="button" class="btn btn-outline-warning" @click="downloadPDF(url_cfe)"><i class="mdi mdi-arrow-down-bold-box" aria-hidden="true"></i>Descargar</button> &nbsp;
        <button type="button" class="btn btn-outline-danger" @click="eliminar_CFE()"> <i class="mdi mdi-delete-forever" aria-hidden="true"></i>  Eliminar</button>

    </div>
    <div class="col-md-12">
        <button v-if="botonGuardar == true" type="button" class="button btn btn-dark" @click="submitForm()">Guardar Informacion de Instalacion </button>
        <button v-else type="button" class="button btn btn-warning" @click="submitFormActualizar()">Actualizar Informacion de Instalacion </button>
        
    </div>
</template>
<script>
import axios from 'axios';
import "vue3-easy-data-table/dist/style.css";
import Swal from 'sweetalert2';
import { mapState, mapMutations } from 'vuex';
import loader from "vue3-ui-preloader";
export default {
  data() {
    return {
        isLoading: false,
        id:'',
        razon_social:'',
        telefono:'',
        email:'',
        rfc:'',
        cfdi:'',
        forma_de_pago:'',
        metodo_de_pago:'',
        regimen_fiscal:'',
        cp_domicilio_fiscal:'',
        constancia_fiscal:'',
        calle:'',
        numero_exterior:'',
        numero_interior:'',
        colonia:'',
        codigo_postal:'',
        municipio:'',
        estado:'',
        url_rfc:'',
        tecnologia:"",
        url_cfe:"",
        pdfFile1:"",
        pdfFile2:'',
        pdfFile3:'',
        botonGuardar:true,
        urlservidor:''
    }
},
created() {
    this.mostrarInformacion();
},
components(){
    loader
},
methods: {
    onFileChangeArchivo(event, fileField){
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            this[fileField] = file;
                this.fileURL = URL.createObjectURL(file);
        } else {
            alert('Por favor, seleccione un archivo PDF.');
        }
            
    },
    async submitForm() {
        const formData = new FormData();
                
        formData.append('razon_social', this.razon_social);
        formData.append('telefono', this.telefono);
        formData.append('email', this.email);
        formData.append('rfc', this.rfc);
        formData.append('cfdi', this.cfdi);
        formData.append('forma_de_pago', this.forma_de_pago);
        formData.append('metodo_de_pago', this.metodo_de_pago);
        formData.append('regimen_fiscal', this.regimen_fiscal);
        formData.append('cp_domicilio_fiscal', this.cp_domicilio_fiscal);
        formData.append('constancia_fiscal', this.constancia_fiscal);
        formData.append('calle', this.calle);
        formData.append('numero_exterior', this.numero_exterior);
        formData.append('numero_interior', this.numero_interior);
        formData.append('colonia', this.colonia);
        formData.append('codigo_postal', this.codigo_postal);
        formData.append('municipio', this.municipio);
        formData.append('estado', this.estado);
        formData.append('tecnologia', this.tecnologia);
        

        
        formData.append('id_cotizacion',localStorage.getItem('idcotizacion'));
        /*if (this.pdfFile1) {
            formData.append('constancia_fiscal', this.pdfFile1);
        }*/
       /*rfc if (this.pdfFile2) {
            formData.append('url_rfc', this.pdfFile2);
        }*/
        if (this.pdfFile3) {
            formData.append('url_cfe', this.pdfFile3);
        }
        try {
        const response = await axios.post(this.$rutaServer + 'informacionCliente', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        console.log(response.data);
        Swal.fire('Guardado!', 'Los datos se guardaron correctamente.', 'success');
        this.mostrarInformacion();
       
      } catch (error) {
        //console.error(error);
        Swal.fire('Error!', 'Hubo un problema al guardar los datos.', 'error');
        if (error.response && error.response.data && error.response.data.errors) {
            // Verificar si el campo 'url_rfc' existe y si es un array con al menos un elemento
            if (Array.isArray(error.response.data.errors.url_rfc) && error.response.data.errors.url_rfc.length > 0) {
                Swal.fire('¡Error!', 'El RFC no debería pesar más de 5 MB.', 'error');
            }
            // Verificar si el campo 'url_cfe' existe y si es un array con al menos un elemento
            if (Array.isArray(error.response.data.errors.url_cfe) && error.response.data.errors.url_cfe.length > 0) {
                Swal.fire('¡Error!', 'El Oficio de CFE no debería pesar más de 5 MB.', 'error');
            }
        } else {
            // Si no existe la estructura de error esperada
            alert(JSON.stringify(error.response.data));
        }
      }
    }, 
    async submitFormActualizar() {
        const formData = new FormData();
                
        formData.append('razon_social', this.razon_social);
        formData.append('telefono', this.telefono);
        formData.append('email', this.email);
        formData.append('rfc', this.rfc);
        formData.append('cfdi', this.cfdi);
        formData.append('forma_de_pago', this.forma_de_pago);
        formData.append('metodo_de_pago', this.metodo_de_pago);
        formData.append('regimen_fiscal', this.regimen_fiscal);
        formData.append('cp_domicilio_fiscal', this.cp_domicilio_fiscal);
        formData.append('constancia_fiscal', this.constancia_fiscal);
        formData.append('calle', this.calle);
        formData.append('numero_exterior', this.numero_exterior);
        formData.append('numero_interior', this.numero_interior);
        formData.append('colonia', this.colonia);
        formData.append('codigo_postal', this.codigo_postal);
        formData.append('municipio', this.municipio);
        formData.append('estado', this.estado);
        formData.append('tecnologia', this.tecnologia);

        formData.append('id_cotizacion',localStorage.getItem('idcotizacion'));
        
        formData.append('id_cliente',this.id);
        /*if (this.pdfFile1) {
            formData.append('constancia_fiscal', this.pdfFile1);
        }*/
        if (this.pdfFile2) {
            formData.append('url_rfc', this.pdfFile2);
        }
        if (this.pdfFile3) {
            formData.append('url_cfe', this.pdfFile3);
        }
        try {
        const response = await axios.post(this.$rutaServer+'actualizarInformacionCliente', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        console.log(response.data);
        Swal.fire('Guardado!', 'Los datos se guardaron correctamente.', 'success');
        this.mostrarInformacion();
       
      } catch (error) {
        console.error(error);
        Swal.fire('Error!', 'Hubo un problema al guardar los datos.', 'error');
      }
    },
    async mostrarInformacion(){
        this.isLoading = true;
        this.urlservidor = this.$rutaServer;
        var idcotizacion = localStorage.getItem('idcotizacion');
        try {
        const response = await axios.post(this.$rutaServer+'consultarInformacionCliente',{id_cotizacion:idcotizacion});
        console.log(response.data.data[0].razon_social);
        
        this.razon_social = response.data.data[0].razon_social;
        this.telefono = response.data.data[0].telefono;
        this.email = response.data.data[0].email;
        this.rfc = response.data.data[0].rfc;
        this.cfdi = response.data.data[0].cfdi;
        this.forma_de_pago = response.data.data[0].forma_de_pago;
        this.metodo_de_pago = response.data.data[0].metodo_de_pago;
        this.regimen_fiscal= response.data.data[0].regimen_fiscal;
        this.cp_domicilio_fiscal = response.data.data[0].cp_domicilio_fiscal;
        this.constancia_fiscal= response.data.data[0].constancia_fiscal;
        this.calle = response.data.data[0].calle;
        this.numero_exterior = response.data.data[0].numero_exterior;
        this.numero_interior = response.data.data[0].numero_interior;
        this.colonia =  response.data.data[0].colonia;
        this.codigo_postal= response.data.data[0].codigo_postal;
        this.municipio = response.data.data[0].municipio;
        this.estado = response.data.data[0].estado;
        if(response.data.data[0].url_rfc){
            this.url_rfc = this.$rutaImagenes+response.data.data[0].url_rfc;
        }
        else{
            this.url_rfc = '';
        }
        if(response.data.data[0].url_cfe){
            this.url_cfe = this.$rutaImagenes+response.data.data[0].url_cfe;

        }
        else{
            this.url_cfe = '';
        }

        /*if(response.data.data[0].constancia_fiscal){
            this.constancia_fiscal = this.$rutaImagenes+response.data.data[0].constancia_fiscal;

        }
        else{
            this.constancia_fiscal = '';
        }*/
        //this.constancia_fiscal = this.$rutaServer+response.data.data[0].constancia_fiscal;
        this.tecnologia = response.data.data[0].tecnologia;
        this.id = response.data.data[0].id;
        localStorage.setItem('idcliente',this.id);
        this.botonGuardar = false;
        this.isLoading = false;
      } catch (error) {
        this.botonGuardar = true;
        this.isLoading = false;
        this.url_rfc = '';
        this.url_cfe = '';
        this.constancia_fiscal = '';
            //console.error(error);
            //Swal.fire('Error!', 'Hubo un problema al guardar los datos.', 'error');
      }
    },
    downloadPDF(descargar) {
        alert(descargar);
        const pdfUrl = descargar;
        // Abrir el PDF en una nueva pestaña
        window.open(pdfUrl, '_blank');
    },
    async eliminar_RFC(){
        const token = localStorage.getItem('accessToken');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept:'application/json'
            }
        };
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: '¡Confirma eliminar archivo rfc!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });
        if (result.isConfirmed) {
        
        var idcliente = localStorage.getItem('idcliente');
            axios.post(this.$rutaServer+'api/eliminarRFC',{idcliente: idcliente },config)
            .then(response => {
                if(response.status == 200){
                    this.mostrarInformacion();
                    Swal.fire('¡Éxito!', 'Archivo RFC eliminado', 'success');
                    
                }
            })
            .catch(error => {
                Swal.fire('¡Error!', 'Ocurrio un error ','error');
            });
        }
                
    },
    async eliminar_CFE(){
        const token = localStorage.getItem('accessToken');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept:'application/json'
            }
        };
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: '¡Confirma eliminar archivo rfc!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });
        if (result.isConfirmed) {
        
        var idcliente = localStorage.getItem('idcliente');
            axios.post(this.$rutaServer+'api/eliminarCFE',{idcliente: idcliente },config)
            .then(response => {
                if(response.status == 200){
                    this.mostrarInformacion();
                    Swal.fire('¡Éxito!', 'Archivo CFE eliminado', 'success');
                    
                }
            })
            .catch(error => {
                Swal.fire('¡Error!', 'Ocurrio un error ','error');
            });
        }
                
    }
},
}
</script>